import { useEffect, useRef, useState } from "react";

const features = [
  {
    icon: "ri-film-line",
    title: "ซีรีส์คุณภาพสูง",
    titleEn: "Premium Content",
    desc: "ซีรีส์สั้นคุณภาพสูงกว่า 10,000 ตอน ครอบคลุมทุกแนว รัก ระทึก ตลก อัปเดตใหม่ทุกวัน",
    color: "from-red-500 to-orange-400",
    bg: "bg-red-50",
    img: "https://readdy.ai/api/search-image?query=beautiful%20Thai%20drama%20series%20short%20video%20content%20on%20smartphone%20screen%20vibrant%20colorful%20entertainment%20app%20interface%20with%20romantic%20scenes%20clean%20white%20background&width=400&height=300&seq=feat-001&orientation=landscape",
  },
  {
    icon: "ri-coin-line",
    title: "ดูแล้วได้เงิน",
    titleEn: "Watch & Earn",
    desc: "ทุกตอนที่ดูได้รับเหรียญทอง สะสมแล้วแลกเป็นเงินสดได้จริง ผ่านระบบที่ปลอดภัย",
    color: "from-yellow-500 to-orange-400",
    bg: "bg-yellow-50",
    img: "https://readdy.ai/api/search-image?query=gold%20coins%20money%20reward%20earning%20concept%20smartphone%20app%20Thai%20baht%20currency%20digital%20wallet%20payment%20clean%20minimal%20background%20warm%20golden%20tones&width=400&height=300&seq=feat-002&orientation=landscape",
  },
  {
    icon: "ri-thumb-up-line",
    title: "ใช้งานง่ายมาก",
    titleEn: "Super Easy",
    desc: "ดาวน์โหลดฟรี สมัครง่าย ดูได้เลย ไม่ต้องลงทุน ไม่ต้องมีทักษะพิเศษ ใครก็ทำได้",
    color: "from-orange-500 to-red-400",
    bg: "bg-orange-50",
    img: "https://readdy.ai/api/search-image?query=happy%20Thai%20woman%20using%20smartphone%20app%20easily%20simple%20interface%20smiling%20relaxed%20casual%20lifestyle%20clean%20bright%20background%20warm%20tones&width=400&height=300&seq=feat-003&orientation=landscape",
  },
];

export default function FeaturesSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="features" className="py-20 md:py-28 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-red-50 text-red-500 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            ทำไมต้องเลือก Hongguo Drama
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            3 เหตุผลที่คุณจะหลงรัก
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            ความบันเทิงระดับพรีเมียม พร้อมรางวัลที่คุณสัมผัสได้จริง
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feat, i) => (
            <div
              key={feat.titleEn}
              className={`rounded-2xl overflow-hidden border border-gray-100 hover:-translate-y-2 transition-all duration-500 cursor-default ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              {/* Image */}
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={feat.img}
                  alt={feat.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className={`p-6 ${feat.bg}`}>
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br ${feat.color} mb-4`}>
                  <i className={`${feat.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{feat.title}</h3>
                <p className="text-sm text-gray-500 font-medium mb-3">{feat.titleEn}</p>
                <p className="text-gray-600 text-sm leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="mt-16 rounded-2xl bg-gradient-to-r from-red-500 to-orange-400 p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
              เริ่มต้นวันนี้ รับโบนัสต้อนรับ!
            </h3>
            <p className="text-white/80">สมัครใหม่รับเหรียญฟรีทันที 3,500+ เหรียญ</p>
          </div>
          <a
            href="#download"
            onClick={(e) => { e.preventDefault(); document.getElementById("download")?.scrollIntoView({ behavior: "smooth" }); }}
            className="flex items-center gap-2 bg-white text-red-500 px-8 py-3 rounded-full font-bold text-lg hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
          >
            <i className="ri-gift-line"></i>
            รับโบนัสเลย
          </a>
        </div>
      </div>
    </section>
  );
}
